export default "__VITE_ASSET__CU20Gmdd__"